export function getPropertyDisplay(className: string, id: string) {
  let displayProperty = ''

  if (id) {
    displayProperty += `#${id.split(' ').join('#')}`
  }

  if (className) {
    displayProperty += ` .${className.split(' ').join('.')}`
  }

  return displayProperty
}
